// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__isOjB","btnOffer":"AddProduct_btnOffer__CNe6o"};